import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { IoIosArrowForward } from "react-icons/io";
import { FaWhatsapp } from "react-icons/fa";
import { TbArrowsSort } from "react-icons/tb";
import { HiDotsVertical } from "react-icons/hi";
import { FaArrowLeftLong } from "react-icons/fa6";
import RegisterNewWhatsapp from './registernewwhatsapp';
import { FaFacebook } from "react-icons/fa";
import axios from "axios";
const navigate = (url) => {
    window.location.href = url;
};
function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (e) {
        return {};
    }
}

function getUserIdFromTokenOrLocatorgarsotrga() {
    if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
        const rawToken = window.locatorgarsotrga("token");
        if (rawToken) {
            const decoded = decodeToken(rawToken);
            const userId = decoded.id || decoded.userId || decoded._id;
            return { userId, token: rawToken };
        }
    }
    const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (rawToken) {
        const decoded = decodeToken(rawToken);
        const userId = decoded.id || decoded.userId || decoded._id;
        return { userId, token: rawToken };
    }
    return { userId: null, token: null };
}
/**
 * WhatsApp Embedded Signup Redirection Flow
 */
function WhatsappEmbeddedSignupModal({ onClose }) {
    const APP_ID = "617614283917585";
    const REDIRECT_URI = "https://wa-api.globebot.io/auth/onboard/redirect";

    const handleOpenSignup = () => {
        const signupUrl = `https://www.facebook.com/v18.0/dialog/oauth?client_id=${APP_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&response_type=code&scope=whatsapp_business_management,whatsapp_business_messaging,business_management,public_profile,email`;
        window.open(signupUrl, "_blank", "popup,width=800,height=900");
        onClose();
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
            <div className="bg-white rounded-lg p-4 w-full max-w-[400px] relative shadow-lg">
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 text-gray-600 hover:text-red-500 font-bold text-lg"
                    aria-label="Close"
                >×</button>
                <h3 className="text-lg font-bold mb-3 flex items-center gap-2">
                    <FaWhatsapp className="text-green-500" />
                    WhatsApp Business Signup
                </h3>
                <div className="mb-5 text-gray-700 text-sm">
                  Click below to sign up or onboard your WhatsApp Business Account via Facebook’s official embedded signup. <br />
                  <span className="text-xs text-gray-500 font-bold">
                    (You will be redirected to Facebook in a new tab)
                  </span>
                </div>
                <button
                  className="w-full flex items-center justify-center gap-2 bg-[#ed7b00] text-white py-2 px-4 rounded font-semibold hover:bg-[#269869] text-sm"
                  onClick={handleOpenSignup}
                >
                  <FaWhatsapp />
                  Continue with WhatsApp Signup
                </button>
            </div>
        </div>
    );
}

const handleEmbeddedSignup2 = () => {
    const userToken = localStorage.getItem("token");
    const extras = {
      feature: "whatsapp_embedded_signup",
      version: 4,
      setup: {
        solutionID: "873684102332639", // 👈 your solution id
      },
    };
  
    const signupUrl = `https://www.facebook.com/v20.0/dialog/oauth?app_id=617614283917585&redirect_uri=${encodeURIComponent("https://wa-api.globebot.io/auth/onboard/redirect")}&response_type=code&display=popup
    &scope=business_management,whatsapp_business_management,whatsapp_business_messaging&extras=${encodeURIComponent(JSON.stringify(extras))}&state=${userToken}&override_default_response_type=true&version=v20.0`;
  
    window.open(signupUrl, "_blank", "width=800,height=900");
  };

const handleEmbeddedSignup = () => {
    const userToken = localStorage.getItem("token");
    const{userId,token} = getUserIdFromTokenOrLocatorgarsotrga();
    console.log("userid", userId)
    alert("userid ",userId )

    if (!userToken) {
        alert("User not logged in");
        return;
    }
    const extras = {
        feature: "whatsapp_embedded_signup",
        sessionInfoVersion: "3",
        version: "v4",
        setup: {
            solutionID: "873684102332639",
        },
    };
    const signupUrl =
      "https://www.facebook.com/dialog/oauth" +
      `?client_id=617614283917585` +
      `&redirect_uri=${encodeURIComponent("https://wa-api.globebot.io/auth/onboard/redirect")}` +
      `&response_type=code` +
      `&scope=business_management,whatsapp_business_management,whatsapp_business_messaging` +
      `&extras=${encodeURIComponent(JSON.stringify(extras))}` +
      `&state=${encodeURIComponent(userId)}`
      ;
  
    window.open(signupUrl, "fbSignup", "width=800,height=900");
};



function formatDate(dateString) {
    if (!dateString) return "—";
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return "—";
    return d.toLocaleDateString() + " " + d.toLocaleTimeString();
}

function WABAChannels() {
    const [open, setopen] = useState(false);
    const [embedSignup, setEmbedSignup] = useState(false);
    const [CompanyWebsiteName, setCompanyWebsiteName] = useState('');
    const [CompanyName, setCompanyName] = useState('');
    const [whatsappData, setWhatsappData] = useState([]);
    const [messageLimits, setMessageLimits] = useState([]); // <-- Store per WABA channel message limits
    const { userId, token } = getUserIdFromTokenOrLocatorgarsotrga();
    const[openDropdown,setOpenDropdown] = useState();

    useEffect(() => {
        window.fbAsyncInit = function () {
            window.FB.init({
                appId: '617614283917585',
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v25.0'
            });
        };
    }, []);

    useEffect(() => {
        const fetchWhatsappData = async () => {
            try {
                const api_url = process.env.REACT_APP_API_URL || "https://wa-api.globebot.io";
                const headers = token ? { Authorization: `${token}` } : {};
                const response = await axios.get(`${api_url}/auth/my-whatsapp`, { headers });
                setWhatsappData(Array.isArray(response.data) ? response.data : []);
            } catch (err) {
                setWhatsappData([]);
            }
        };
        fetchWhatsappData();
    }, [token]);

    // Fetch message limit for each WhatsApp number in list
    useEffect(() => {
        const fetchMessageLimits = async () => {
            if (!Array.isArray(whatsappData) || whatsappData.length === 0) {
                setMessageLimits([]);
                return;
            }
            try {
                const api_url = process.env.REACT_APP_API_URL || "https://wa-api.globebot.io";
                // Map over each WhatsApp channel and fetch its limit in parallel
                const results = await Promise.all(
                    whatsappData.map(async (item) => {
                        const phone_number_id = item?.phone_number_id;
                        const fbToken = item?.access_token;
                        console.log("phone number id ", phone_number_id);
                        if (!phone_number_id || !fbToken) return { limit: "—" };
                        try {
                            const response = await axios.get(
                                `${api_url}/auth/message-limit`,
                                {
                                    params: {
                                      phone_number_id,
                                      fbToken
                                    }
                                  }
                            );
                            return {
                                limit:
                                    typeof response.data?.whatsapp_business_manager_messaging_limit !== "undefined"
                                        ? (typeof response.data?.whatsapp_business_manager_messaging_limit === "string"
                                            ? `${response.data.whatsapp_business_manager_messaging_limit.replace(/^TIER_?/, '').replace(/K$/, '000').replace(/([0-9]+)$/, (m) => parseInt(m).toLocaleString())}\n(${response.data.whatsapp_business_manager_messaging_limit})`
                                       
                                            : response.data?.whatsapp_business_manager_messaging_limit)
                                   
                                        : "—"
                            };
                        } catch (err) {
                            return { limit: "—" };
                        }
                    })
                );
                setMessageLimits(results.map(r => r.limit));
            } catch (err) {
                setMessageLimits([]);
            }
        };
        fetchMessageLimits();
    }, [whatsappData]);

    const columns = [
        "WABA Number",
        "PhoneNumber Id",
        "WABA BusinessId",
        "Messaging Limit",
        "Quality Rating",
        "Default",
        "Display Name",
        "ConfigureDate",
        "Webhook Url",
        "Actions"
    ];

    return (
        <>
            <div className='px-2 dark:bg-[#121519] h-[100vh] pl-4'>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1 '>
                    <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff] flex items-center'>
                        <Link to='/configuration'><FaArrowLeftLong /></Link> WABAChannels
                    </h1>
                    <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>
                        <span>Home</span> <IoIosArrowForward /><span>Configuration</span><IoIosArrowForward />
                        <span>WABAChannels</span>
                    </div>
                </div>
                <div className='w-[100%] mt-2 flex flex-col items-start gap-2'>
                    <button
                        type="button"
                        onClick={() => setopen(true)}
                        className='bg-[#ed7b00] flex items-center text-[13px] text-[#fff] font-bold p-2 gap-1 rounded-lg'>
                        <FaWhatsapp />
                        Register New WhatsApp
                    </button>
                    <button
                        type="button"
                        onClick={() => setEmbedSignup(true)}
                        className='bg-[#316bb0] flex items-center text-[13px] text-[#fff] font-bold px-3 py-2 gap-1 rounded-lg hidden'>
                        <FaWhatsapp />
                        WhatsApp Embedded Signup
                    </button>
                </div>
                <table className="w-full overflow-hidden border-[1px] border-[#dee2e6] mt-2">
                    <thead>
                        <tr className="text-left text-sm font-semibold text-gray-700">
                            {columns.map((col, i) => (
                                <th key={col} className="p-2 cursor-pointer border-[1px] border-[#dee2e6] ">
                                    <div className="flex justify-between items-center gap-2">
                                        <span className='text-[11px] text-[#576071] dark:text-[#fff]'>{col}</span>
                                        <button type="button" className="text-gray-500 hover:text-black">
                                            <TbArrowsSort />
                                        </button>
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {whatsappData.length === 0 ? (
                            <tr>
                                <td colSpan={columns.length} className="text-center text-gray-400 text-[13px] p-4">
                                    No WhatsApp channels found.
                                </td>
                            </tr>
                        ) : (
                            whatsappData.map((row, idx) => (
                                <tr key={row["phone_number_id"] || idx} className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
                                    {/* 1: WABA Number */}
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6]">
                                        {row["WABA Number"] || "—"}
                                    </td>
                                    {/* 2: PhoneNumber Id */}
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6]">
                                        {row["PhoneNumber Id"] || row["phone_number_id"] || "—"}
                                    </td>
                                    {/* 3: WABA BusinessId */}
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6]">
                                        {row["WABA BusinessId"] || row["waba_id"] || "—"}
                                    </td>
                                    {/* 4: Messaging Limit */}
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6]">
                                        {typeof messageLimits[idx] !== 'undefined' ? (
                                            <span className="flex items-center gap-1 text-[#3170e0] font-bold">
                                                <svg width="12" height="12" viewBox="0 0 20 20" fill="currentColor" style={{ color: "#3170e0" }}>
                                                  <path d="M7.629 14.98a1 1 0 0 1-1.372.21l-.089-.08-3.54-3.668a1 1 0 0 1 1.416-1.412l2.708 2.805 6.324-7.659a1 1 0 1 1 1.546 1.278l-7.003 8.526z"/>
                                                </svg>
                                                {messageLimits[idx]}
                                            </span>
                                        ) : "—"}
                                    </td>
                               
                                    {/* 5: Quality Rating */}
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6]">
                                        {row["Quality Rating"] ? (
                                            row["Quality Rating"].toLowerCase() === "green" ? (
                                                <span style={{ color: "#25d366", fontWeight: "bold" }}>High</span>
                                            ) : row["Quality Rating"].toLowerCase() === "yellow" ? (
                                                <span style={{ color: "#f59e0b", fontWeight: "bold" }}>Low</span>
                                            ) : (
                                                <span style={{ color: "#576071", fontWeight: "bold" }}>
                                                    {row["Quality Rating"]}
                                                </span>
                                            )
                                        ) : "—"}
                                    </td>
                               
                                    {/* 6: Default (not present in response, show —) */}
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6]">
                                        {"—"}
                                    </td>
                                    {/* 7: Display Name */}
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6]">
                                        {row["Display Name"] || "—"}
                                    </td>
                                    {/* 8: ConfigureDate */}
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6]">
                                        {row["ConfigureDate"] ? formatDate(row["ConfigureDate"]) : "—"}
                                    </td>
                                    {/* 9: Webhook Url (not present in response, show —) */}
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6]">
                                        {"—"}
                                    </td>
                                    {/* 10: Actions */}
                                    <td className="p-1 text-[11px] border-[1px] border-[#dee2e6]">
                                        <div className="flex justify-center items-center cursor-pointer relative group">
                                            <HiDotsVertical 
                                                className="text-[16px] text-gray-600 dark:text-white hover:text-black dark:hover:text-gray-300 transition"
                                                onClick={e => {
                                                    e.stopPropagation();
                                                    setOpenDropdown(idx === openDropdown ? null : idx);
                                                }}
                                            />
                                            {/* Dropdown */}
                                            {openDropdown === idx && (
                                                <div className="absolute right-0 mt-2 w-44 bg-white border border-gray-200 rounded shadow-lg z-10"
                                                     onClick={e => e.stopPropagation()}>
                                                    <button
                                                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                                        onClick={() => {
                                                            // Navigate to Business Profile
                                                            // You can use navigation with state to pass props data. If you're using React Router v6,
                                                            // you can use the `useNavigate` hook with a state param.
                                                            // Example with optional state passing:
                                                            // To send data to the BusinessProfile page, use localStorage or URL params.
                                                            // Here is an example using localStorage before navigating:
                                                            // Instead of storing the whole row (which may contain sensitive data) in localStorage,
                                                            // pick only fields that the BusinessProfile page actually needs.
                                                            const wabaProfileFields = [
                                                                "Display Name",
                                                                "PhoneNumber Id",
                                                                "WABA Number",
                                                                "WABA BusinessId",
                                                                "Quality Rating",
                                                                "ConfigureDate",
                                                                "account_id",
                                                                "phone_number_id",
                                                                "waba_id"
                                                            ];
                                                            const wabaDataToPass = {};
                                                            wabaProfileFields.forEach(key => {
                                                                if (row[key] !== undefined) wabaDataToPass[key] = row[key];
                                                            });
                                                            localStorage.setItem(
                                                                "wabaData",
                                                                JSON.stringify(wabaDataToPass)
                                                            );
                                                 
                                                            navigate(
                                                                `/WAMessage/WABusinessProfile/BusinessProfile?id=${encodeURIComponent((row.phone_number_id || "").replace(/\s+/g, ""))}`
                                                            );
                                                            // On the BusinessProfile page, you can retrieve with:
                                                            // const wabaData = JSON.parse(localStorage.getItem("wabaData") || "{}");
                                           
                                             
                                                        }}
                                                    >
                                                        Business Profile
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </td>
                           
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
                <RegisterNewWhatsapp isOpen={open} onClose={() => setopen(false)} heading='Get started with WhatsApp’s Business API'>
                    <div className='w-[100%] border-y-[1px] border-[#e3e9ef] mt-3 pb-6'>
                        <p className='text-[#58595a] text-[12px] font-semibold '>
                            WhatsApp is one of the most popular communication applications in the world. WhatsApp is a Facebook company and requires a Facebook account and Facebook Business Manager to set up.
                        </p>
                        <h6 className='text-[#000] text-[14px] font-semibold mt-4'>👉🏻 What you will need</h6>
                        <ul className="text-[#58595a] text-[13px] font-semibold list-disc pl-5 space-y-1 mt-2">
                            <li>Access to Facebook Business Manager</li>
                            <li>A viable Phone Number for WhatsApp</li>
                            <li>Your business’s legal address and details</li>
                            <li>Verify your Facebook Business</li>
                            <li>Full access to the WhatsApp Business account</li>
                            <li>The ID should belong to the business you manage</li>
                            <li>FB user ID must manage templates, phone numbers, QR codes</li>
                        </ul>
                        <div className="w-[100%] flex items-center justify-between gap-3 mt-4">
                            <label className="text-[#121519] text-[12px] font-semibold">
                                Company Website:
                            </label>
                            <input
                                type="text"
                                value={CompanyWebsiteName}
                                onChange={e => setCompanyWebsiteName(e.target.value)}
                                placeholder="Company Website"
                                className="text-[#58595abd] text-[13px] font-bold border border-[#d4cfcf] px-2 py-2 rounded outline-none placeholder:text-[#d4cfcf] w-[70%]"
                            />
                        </div>
                        <div className="w-[100%] flex items-center justify-between gap-3 mt-4">
                            <label className="text-[#121519] text-[12px] font-semibold">
                                Company Name:
                            </label>
                            <input
                                type="text"
                                value={CompanyName}
                                onChange={e => setCompanyName(e.target.value)}
                                placeholder="Company Name:"
                                className="text-[#58595abd] text-[13px] font-bold border border-[#d4cfcf] px-2 py-2 rounded outline-none placeholder:text-[#d4cfcf] w-[70%]"
                            />
                        </div>
                        <h6 className='text-[#000] text-[14px] font-semibold mt-4'>👉🏻 To continue you need access to your Facebook business account, including:</h6>
                        <ul className="text-[#58595a] text-[13px] font-semibold list-disc pl-5 space-y-1 mt-2">
                            <li>Your company’s <span className='text-[#3fca90] font-bold'>legal name and address </span></li>
                            <li>A display name and short description</li>
                            <li>A valid email address</li>
                            <li>A valid mobile number</li>
                            <li>A business-owned phone number</li>
                        </ul>
                    </div>
                    <div className='w-[100%] flex justify-end gap-1 mt-2'>
                        {/* Primary Button */}
                        <button className="bg-[#316bb0] text-white text-[12px] font-semibold px-4 py-2 rounded hover:bg-[#25548c] transition flex items-center gap-1"
                            onClick={handleEmbeddedSignup}
                        >
                            <FaFacebook />
                            Continue with Facebook
                        </button>
                        {/* Cancel Button */}
                        <button
                            type="button"
                            onClick={() => setopen(false)}
                            className="bg-[#e92b2b] text-white text-[12px] font-semibold px-4 py-2 rounded hover:bg-[#b81f1f] transition">
                            Cancel
                        </button>
                    </div>
                </RegisterNewWhatsapp>
                {/* WhatsApp Embedded Signup Modal, opens real flow in new tab */}
                {embedSignup && (
                    <WhatsappEmbeddedSignupModal onClose={() => setEmbedSignup(false)} />
                )}
            </div>
        </>
    );
}

export default WABAChannels;
